<template>
  <div class="footers">
    <div data-v-45b128b4="" class="flex-col self-stretch group_10">
      <div class="flex-col section_10">
        <div class="flex-col justify-start items-center self-start text-wrapper_12">
          <span class="font">友情链接</span>
        </div>
        <div class="flex-row self-stretch group_18">
          <div v-for="(item, index) in friendList" class="flex-col justify-start items-center text-wrapper_13" :key="index" @click="goNewLink(item)">
            <span class="font_8 text">{{item.name}}</span>
          </div>
          <!--<div class="ml-38 flex-col justify-start items-center text-wrapper_13">-->
            <!--<span class="font_8 text">国家市场监督管理总局</span>-->
          <!--</div>-->
          <!--<div class="ml-38 flex-col justify-start items-center text-wrapper_13 view_6">-->
            <!--<span class="font_8 text">中国合格评定国家认可委员会</span>-->
          <!--</div>-->
        </div>
      </div>
      <div data-v-45b128b4="" class="flex-col section_8">
        <div data-v-45b128b4="" class="flex-row relative group_12">
          <div data-v-45b128b4="" class="flex-row justify-between group_13 pos_2">
            <div data-v-45b128b4="" class="flex-col self-start group_14">
              <div data-v-45b128b4="" class="flex-row items-center self-stretch">
                <img data-v-45b128b4="" :src="footerContact" class="shrink-0 image_10">
                <span data-v-45b128b4="" class="font_4 text_13 ml-17">联系我们</span>
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="item">
              <img data-v-45b128b4="" :src="footerPhone" class="image_11">
              <p class="word-box">
                <span data-v-45b128b4="" class="key">电话</span>
                <span data-v-45b128b4="" class="value">{{comm.tel}}</span>
              </p>
            </div>
            <!--<div class="item">-->
              <!--<img data-v-45b128b4="" :src="footerEmail" class="image_13">-->
              <!--<p class="word-box">-->
                <!--<span data-v-45b128b4="" class="key">邮箱</span>-->
                <!--<span data-v-45b128b4="" class="value">rzw@camet.org.cn</span>-->
              <!--</p>-->
            <!--</div>-->
            <div class="item">
              <img data-v-45b128b4="" :src="footerLocation" class="image_12">
              <p class="word-box">
                <span data-v-45b128b4="" class="key">地址</span>
                <span data-v-45b128b4="" class="value address">{{comm.address}}</span>
              </p>
            </div>
          </div>

          <div data-v-45b128b4="" class="flex-row group_15">
            <div data-v-45b128b4="" class="flex-row items-center group_16">
              <span data-v-45b128b4="" class="font_6">© 2024</span>
              <span data-v-45b128b4="" class="font_6 ml-3">中国电器工业协会 电工行业高质量发展合格评定创新平台</span>
            </div>
            <span data-v-45b128b4="" class="font_6">版权所有</span>
            <span data-v-45b128b4="" class="font_6">京ICP备09041796号-1</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    const {
      footerContact,
      footerPhone,
      footerEmail,
      footerLocation
    } = this.$images
    return {
      footerContact,
      footerPhone,
      footerEmail,
      footerLocation,
      friendList: [
        // {name: 'xxx', link: 'xxx'}
      ],
      comm: {
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // 获取友情链接
      this.getFriendList()
      // 获取公共数据
      this.getComm()
    },
    async getFriendList () {
      const res = await this.$https.getLinks()
      this.friendList = res.data.data.map(v => {
        return {
          name: v.name,
          link: v.link
        }
      })
    },
    goNewLink (item) {
      const { link } = item
      window.open(link, '_blank')
    },
    async getComm () {
      const res = await this.$https.comm()
      this.comm = res.data.data
      this.$store.state.isRuleDetail = res.data.data.open_rzgz_detail === '1'
    }
  }
}
</script>

<style lang="less" scoped>

  .section_10 {
    padding: 62px 244px 0;
    background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=09c186d4de6c84c115912f883e32e11b.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .text-wrapper_12 {
      padding: 14px 0;
      background-color: #006ed1;
      width: 164px;
      font-size: 18px;
      color: white;
    }
    .group_18 {
      padding: 26px 6px 49px;
      .text-wrapper_13 {
        flex: 1 1 446px;
        padding: 28px 0;
        background-color: #e0edf9;
        height: 75px;
        border-left: solid 1px #006ed1;
        border-right: solid 1px #006ed1;
        border-top: solid 1px #006ed1;
        border-bottom: solid 1px #006ed1;
        margin-right: 38px;
        cursor: pointer;

        &:nth-child(3n){
          margin-right: 0px;
        }
      }
      .view_6 {
        margin-right: 3px;
      }
    }
  }
  .group_10 {
    .section_6 {
      width: 100%;
      /*padding: 46px 246px 41px;*/
      background-image: url('https://ide.code.fun/api/image?token=67111f341511d900114ad90f&name=c0e8276eb842e1067dedc338ab48f09e.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding-top: 46px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .section_7 {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
        left: -648px;
        width: 164px;
        height: 46px;
        background-color: #006ed1;
        .image_9 {
          width: 26px;
          height: 26px;
        }
        .text_12 {
          height: 18px;
          font-family: PingFang;
          font-weight: 800;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 22px;
          margin-left: 10px;
        }
      }
      .group_11 {
        display: flex;
        flex-direction: column;
        width: 1920px;
        align-items: center;
        padding: 27px 6px 68px;

        .flex-row{
          display: flex;
          flex-direction: row;
        }

        .text-wrapper_2 {
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #e0edf9;
          height: 74px;
          border-left: solid 1px #006ed1;
          border-right: solid 1px #006ed1;
          border-top: solid 1px #006ed1;
          border-bottom: solid 1px #006ed1;
          width: 330px;
          height: 72px;
          background: #E0EDF9;
          border: 1px solid #006ED1;
          flex-shrink: 0;
          margin-bottom: 22px;
          margin-right: 30px;

          .text{
            font-family: PingFang;
            font-family: PingFang;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            line-height: 28px;
          }
        }
        .text-wrapper_3 {
          display: flex;
          justify-content: center;
          align-items: center;
          border-left: solid 1px #006ed1;
          border-right: solid 1px #006ed1;
          border-top: solid 1px #006ed1;
          border-bottom: solid 1px #006ed1;
          width: 330px;
          height: 72px;
          background: #E0EDF9;
          border: 1px solid #006ED1;
          flex-shrink: 0;
          margin-right: 30px;

          .text{
            font-family: PingFang;
            font-family: PingFang;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            line-height: 28px;
          }
        }
      }
    }
    .section_8 {
      padding: 8px 0 37px;
      background-image: url('https://ide.code.fun/api/image?token=67111f341511d900114ad90f&name=75fa7447de05642c51ee4489989b7d55.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #2e3142;

      .group_12 {
        /*padding: 106px 360px 30px;*/
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .item-box{
          width: 1231px;
          display: flex;
          flex-direction: row;
          align-items: center;
          margin: 30px 0px;

          .item{
            min-width: 311px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .word-box{
              display: flex;
              flex-direction: column;
              margin-left: 16px;

              .key{
                font-weight: bold;
                font-size: 16px;
                color: #B2B3B8;
                line-height: 30px;
              }

              .value{
                font-weight: bold;
                font-size: 24px;
                color: #006ED1;
                line-height: 38px;

                &.address{
                  font-size: 20px;
                }
              }
            }
          }
        }

        .self-stretch{
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .image_11 {
          width: 40px;
          height: 43px;
        }
        .pos_3 {
          /*position: absolute;*/
          /*left: 362px;*/
          /*bottom: 38px;*/
        }
        .image_13 {
          width: 48px;
          height: 36px;
        }
        .pos_7 {
          position: absolute;
          left: 673px;
          bottom: 39px;
        }
        .font_5 {
          font-size: 16px;
          font-family: PingFang;
          line-height: 16px;
          color: #b2b3b8;
        }
        .pos_4 {
          position: absolute;
          left: 734px;
          bottom: 66px;
        }
        .text_15 {
          color: #006ed1;
          font-size: 24px;
          font-family: PingFang;
          font-weight: 700;
          line-height: 20px;
        }
        .pos_8 {
          position: absolute;
          left: 418px;
          bottom: 34px;
        }
        .font_4 {
          font-size: 24px;
          font-family: PingFang;
          line-height: 23px;
        }
        .text_16 {
          color: #006ed1;
        }
        .pos_9 {
          position: absolute;
          left: 735px;
          bottom: 30px;
        }
        .image_12 {
          width: 31px;
          height: 43px;
        }
        .pos_6 {
          position: absolute;
          right: 877px;
          bottom: 37px;
        }
        .pos_5 {
          position: absolute;
          right: 834px;
          bottom: 66px;
        }
        .group_13 {
          width: 1231px;
          .group_14 {
            margin-top: 39px;
            .image_10 {
              width: 41px;
              height: 41px;
            }
            .text_13 {
              color: #b2b3b8;
              margin-left: 17px;
            }
            .text_14 {
              line-height: 15px;
            }
          }
          .text_17 {
            margin-top: 135px;
            color: #006ed1;
            font-size: 20px;
            font-family: PingFang;
            line-height: 20px;
          }
          .section_9 {
            background-color: #2e3142;
            width: 204px;
            height: 188px;
          }
        }
      }
      .group_15 {
        width: 1231px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .group_16 {
          width: 466px;
        }
        .font_6 {
          font-size: 14px;
          font-family: PingFang;
          line-height: 11px;
          color: #939598;
          margin-right: 16px;
        }
      }
    }
  }
  .text {
    text-transform: uppercase;
  }
</style>
